import type { ReactNode } from 'react'
import type { Control } from 'react-hook-form'
import type { UploadEntry } from '@shared/types/file-upload.types'
import type { ContactChannel } from '../components/page'
import { DescriptionField } from '../components/steps/fields/description-field'
import { FileUploadField } from '../components/steps/fields/file-upload-field'
import { OrderSelectionField } from '../components/steps/fields/orderSelectionField/order-selection-field'
import { ProjectSelectionField } from '../components/steps/fields/projectSelectionField/project-selection-field'
import { OrderNumberField } from '../components/steps/fields/order-number-field'
import { WebsiteDomainField } from '../components/steps/fields/website-domain-field'

export interface FieldRenderContext {
  channel: ContactChannel
  intentId: string
  entries: UploadEntry[]
  addFiles: (files: File[]) => void
  removeEntry: (id: string) => void
}

export interface IssueDescriptionFields {
  description: string
  selectedLineItemIds: string[]
  selectedWorkIds: string[]
  orderNumber: string
  websiteDomain: string
}

export const MAX_DESCRIPTION_LENGTH = 1000
export const MIN_DESCRIPTION_LENGTH = 15
export const MAX_ATTACHMENTS = 4

export interface FieldConfig {
  id: string
  condition?: (ctx: FieldRenderContext) => boolean
  render: (control: Control<IssueDescriptionFields>, ctx: FieldRenderContext) => ReactNode
}

export const ISSUE_DESCRIPTION_FIELDS: FieldConfig[] = [
  {
    id: 'description',
    render: (control) => <DescriptionField control={control} />,
  },
  {
    id: 'selectedLineItemIds',
    condition: ({ intentId }) => intentId === 'help_with_my_order',
    render: (control) => <OrderSelectionField control={control} />,
  },
  {
    id: 'orderNumber',
    condition: ({ intentId }) => intentId === 'help_with_my_order',
    render: (control) => <OrderNumberField control={control} />,
  },
  {
    id: 'selectedWorkIds',
    condition: ({ intentId }) => intentId === 'help_with_my_design',
    render: (control, { channel }) => <ProjectSelectionField control={control} channel={channel} />,
  },
  {
    id: 'websiteDomain',
    condition: ({ intentId }) => intentId === 'website_and_domains',
    render: (control) => <WebsiteDomainField control={control} />,
  },
  {
    id: 'fileUpload',
    condition: ({ channel }) => channel === 'email',
    render: (_control, { entries, addFiles, removeEntry }) => <FileUploadField entries={entries} addFiles={addFiles} removeEntry={removeEntry} />,
  },
]
